import { render } from "./Cotizacion.vue?vue&type=template&id=38e1c092&scoped=true"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"

import "./Cotizacion.vue?vue&type=style&index=0&id=38e1c092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e1c092"]])

export default __exports__